import React, { Component } from 'react'
import { SocialMedia } from '../../components'
import { OptionsHOC } from '../../hocs'

class SocialMediaContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showButtons: false
    }
  }

  buttonToggle = () => {
    const { showButtons } = this.state
    let buttons
    if (showButtons === false) {
      buttons = true
    } else {
      buttons = false
    }
    this.setState({ showButtons: buttons })
  }

  render() {
    const { contentId, contentType, contentTitle, getOption, version } = this.props
    const { showButtons } = this.state
    const facebook = getOption('shareButton.facebook', true)
    const twitter = getOption('shareButton.twitter', true)
    const mail = getOption('shareButton.mail', true)

    return (
      <SocialMedia
        buttonToggle={this.buttonToggle}
        showButtons={showButtons}
        contentId={contentId}
        contentType={contentType}
        contentTitle={contentTitle}
        facebook={facebook}
        twitter={twitter}
        mail={mail}
        version={version}
      />
    )
  }
}

export default OptionsHOC(SocialMediaContainer)



// WEBPACK FOOTER //
// ./src/containers/SocialMedia/SocialMedia.js